var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("FullLoader", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "mobile create-prize-btn",
            style: { opacity: _vm.loading ? 0 : 1 }
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.createPrizeScreen()
                  }
                }
              },
              [_vm._v("Create Prize")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex justify-content-between align-items-center page-header",
              style: { opacity: _vm.loading ? 0 : 1 }
            },
            [
              _c(
                "a",
                {
                  staticClass: "header-action",
                  attrs: {
                    href: this.gevmeLink,
                    "data-toggle": "tooltip",
                    title: "Back to GEVME!"
                  }
                },
                [
                  _c("img", {
                    staticClass: "header-action back",
                    attrs: { src: require("@/assets/images/arrow-left.svg") }
                  })
                ]
              ),
              _vm._v(" "),
              _c("h1", [
                _vm._v(
                  "\n          " +
                    _vm._s(this.eventDetail.name) +
                    "\n          "
                ),
                _c("img", {
                  staticClass: "path-separator",
                  attrs: { src: require("@/assets/images/path_separator.svg") }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn dropdown-toggle",
                      staticStyle: { padding: "0" },
                      attrs: { type: "button", "data-toggle": "dropdown" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(this.prizeMenu) +
                          "\n              "
                      ),
                      _c("span", { staticClass: "caret" })
                    ]
                  ),
                  _vm._v(" "),
                  _c("ul", { staticClass: "dropdown-menu" }, [
                    _c(
                      "li",
                      {
                        style: {
                          backgroundColor: _vm.deleted ? "#fff" : "#f8f9fb"
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToDashboard()
                          }
                        }
                      },
                      [_vm._v("Prizes")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        style: {
                          backgroundColor: _vm.deleted ? "#f8f9fb" : "#fff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deletedPrizes()
                          }
                        }
                      },
                      [_vm._v("Deleted Prizes")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToPublicDrawSettings()
                          }
                        }
                      },
                      [_vm._v("Public Draw Settings")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desktop" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.createPrizeScreen()
                      }
                    }
                  },
                  [_vm._v("Create Prize")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 flex-table dashboard-prizes-table",
              style: { opacity: _vm.loading ? 0 : 1 }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.prizes_list, function(prize, index) {
                return _vm.prizes_list.length > 0
                  ? [
                      _c("PrizeTableRow", {
                        key: prize.prize_name,
                        attrs: {
                          prize: prize,
                          index: index,
                          deleted: _vm.deleted
                        }
                      })
                    ]
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.prizes_list.length === 0
                ? _c("div", { staticClass: "empty-prize" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/cup.svg"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex-table-header d-flex align-items-center" },
      [
        _c("div", { staticClass: "column c-prize-name" }, [
          _vm._v("Prize name")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column c-status" }, [_vm._v("status")]),
        _vm._v(" "),
        _c("div", { staticClass: "column c-list desktop" }, [
          _vm._v("list(s)")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column c-winners desktop" }, [
          _vm._v("winners")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column type-date c-created desktop" }, [
          _vm._v("created on")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column type-date c-modified desktop" }, [
          _vm._v("modified on")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column c-modified-by desktop" }, [
          _vm._v("modified by")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column c-action" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "msg" }, [
      _vm._v(
        "\n            You haven’t added any prize to this event yet.\n            "
      ),
      _c("br"),
      _vm._v("Click\n            "),
      _c("a", { attrs: { href: "#/create-prize" } }, [_vm._v("here")]),
      _vm._v(" to add new Prize\n          ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72011e16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72011e16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardContent.vue
// module id = null
// module chunks = 